@if (isModalOpen()) {
  <clr-modal
    [clrModalOpen]="isModalOpen()"
    (clrModalOpenChange)="isModalOpen.set($event)"
    [clrModalSize]="'xl'"
    [clrModalClosable]="true">
    <h3 class="modal-title">
      {{ 'Beschreibung' | mrTranslate }} {{ isReadOnly() ? '' : ('verwalten' | mrTranslate) }}
    </h3>
    <div class="modal-body clr-row nxm">
      <app-preview-thumbnails
        [class.openedPDF]="pdfUrl() != null"
        [data]="media()"
        [readonly]="isReadOnly()"
        [drag_drop]="true"
        [maxAmount]="1"
        [acceptTypes]="'image/*, .pdf'"
        (clearedThumb)="pdfUrl.set(null)"
        (lastUpload)="checkPDF($event)"
        (openPdfOverlay)="showPDF($event)"
        [skipSavedOnPack]="false"
        [allowCameraVideo]="false" />
      @if (pdfUrl() != null) {
        <iframe [attr.src]="pdfUrl()" style="border: none; width: 100%; height: 50svh; z-index: 1"></iframe>
      }
      @if (isReadOnly()) {
        <div class="clr-row nxm">
          <h4 class="clr-col-12">{{ 'Beschreibung' | mrTranslate }}</h4>
          <p class="clr-col-12">{{ helper().HelpBeschreibung }}</p>
        </div>
      } @else {
        <form
          id="hilfe-beschreibung-form"
          (ngSubmit)="saveHelper(helperText.value)"
          clrForm
          class="clr-col-12 width100"
          clrLayout="vertical">
          <clr-textarea-container class="mt-0">
            <label>{{ 'Beschreibung' | mrTranslate }}</label>
            <textarea
              clrTextarea
              name="helperText"
              [autofocus]="isModalOpen()"
              #helperText="ngModel"
              [ngModel]="helper().HelpBeschreibung"></textarea>
          </clr-textarea-container>
        </form>
      }
    </div>
    <div class="modal-footer">
      @if (!isReadOnly()) {
        <button class="btn btn-primary" type="submit" form="hilfe-beschreibung-form">
          {{ 'OK' | mrTranslate }}
        </button>
      }
      <button type="button" class="btn" (click)="isModalOpen.set(false)">
        {{ (isReadOnly() ? 'Schliessen' : 'Abbrechen') | mrTranslate }}
      </button>
    </div>
  </clr-modal>
}
